import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { RootState } from "model/state";
import { Dispatch } from "redux";

import { DeveloperMenuSettings } from "model";
import { clearMessage } from "actions";
import { selectHasErrorMessage } from "selectors";
import { DeveloperMenuModal } from "components/DeveloperMenu/DeveloperMenuModal";
import {
  changeDeveloperMenuSettings,
  fetchDeveloperMenuSettings,
  updateDeveloperMenuSettings,
} from "actions/Device";
import {
  selectIsSubmittingDeveloperMenu,
  selectDeveloperMenuSettings,
} from "selectors/DeveloperMenu";

type SelectedValues = {
  isSubmitting: boolean;
  settings: DeveloperMenuSettings | null;
  hasError: boolean;
};

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isSubmitting: selectIsSubmittingDeveloperMenu(),
  settings: selectDeveloperMenuSettings(),
  hasError: selectHasErrorMessage(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSave: () => {},
  fetchDeveloperMenuSettings: (deviceId: string) =>
    dispatch(fetchDeveloperMenuSettings(deviceId)),
  updateDeveloperMenuSettings: (
    deviceId: string,
    settings: DeveloperMenuSettings
  ) => dispatch(updateDeveloperMenuSettings(deviceId, settings)),
  changeDeveloperMenuSettings: (
    settings: DeveloperMenuSettings
  ) => dispatch(changeDeveloperMenuSettings(settings)),
  clearMessage: () => dispatch(clearMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeveloperMenuModal);
